import axios from 'axios'
import common from './common';
import {Message} from 'element-ui'
import router from '../router';
import urls from './url'

// https://www.knowledgesource.cn  //给客户看的线上版本
// http://zkcx.cxstar.cn  //本公司线上版本

const baseURL = common.baseUrl
// const baseURL = process.env.NODE_ENV === 'development' ? common.localUrl : common.localUrl
// const baseURL = process.env.NODE_ENV === 'development' ? 'https://www.knowledgesource.cn' : 'https://www.knowledgesource.cn'
// const baseURL = 'http://zkcx.cxstar.cn/'

const service = axios.create({
  baseURL,
  timeout: 3000000
})
service.interceptors.request.use(
  (config) => {
    if (localStorage.getItem('token')) {
      config.headers["If-Modified-Since"] = "0"
      config.headers["Cache-Control"] = "no-cache"
      config.headers.common['Authorization'] = localStorage.getItem('token')
    }    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      const data = response.data
      if (data.cxajaxrc !== 0) {
        Message({
          dangerouslyUseHTMLString:true,
          message: `<span style='font-size:22px;'>${data.cxajaxerrmsg}</span>`,
          type: 'error',
          duration:3000,
          offset: 400,
          center: true
        })
      }
      return data
    }
  },
  (error) => {
    Message({
      dangerouslyUseHTMLString:true,
      message: `<span style='font-size:22px;'>${error.cxajaxerrmsg}</span>`,
      type: 'error',
      duration:3000,
      offset: 400,
      center: true
    })
    return Promise.reject(error)
  }
)


export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js